export const DUMMY_CATEGORIES =
  'https://www.themealdb.com/api/json/v1/1/categories.php';

export const MIKOM_API = 'https://api.mobrespos.com/get_image';
export const MIKOM_API_IMAGE = 'https://1zw31qczi7.execute-api.eu-central-1.amazonaws.com/prod/';